import classnames from 'classnames';
import React__default from 'react';
import { mergeProps } from './merge_props.js';
import { area, control } from './focus_area.css.js';

/**
 * Provides styling context for a focus area via className.
 */
const FocusArea = ({ children }) => {
    if (React__default.isValidElement(children)) {
        const props = {
            className: classnames(children.props.className, area),
        };
        return React__default.cloneElement(children, props);
    }
    return React__default.createElement("div", { className: area }, children);
};
/**
 * Provides styling context for a control inside a focus area via className.
 */
const FocusAreaControl = React__default.forwardRef(function FocusAreaControl({ children, ...rest }, ref) {
    if (React__default.isValidElement(children)) {
        const props = {
            ...mergeProps(children.props, rest),
            ref,
            className: classnames(children.props.className, control),
        };
        return React__default.cloneElement(children, props);
    }
    return React__default.createElement(React__default.Fragment, null, children);
});

export { FocusArea, FocusAreaControl };
